import {i18n} from '@/locales/i18n';
import type {AvailabilityResult, DetailResult, PosMaterialResult} from '@/types/search/result';
import {useFetch} from '@vueuse/core';
import type {Product} from 'dummen-shared';

const languageIso = window.languageIso;
const websiteBaseUrl = window.websiteBaseUrl;
const catalogBaseUrl = `${import.meta.env.VITE_CATALOG_BASE_URL}/${languageIso}`;
const productDetailPath = import.meta.env.VITE_PRODUCT_DETAIL;

export const fetchRegions = async (selectedRegion: string | null) => {
	const locale = (i18n.global.locale as any).value;

	const {
		data,
		error
	} = await useFetch(`${websiteBaseUrl}/app/regions?iso=${locale}&selectedRegion=${selectedRegion}`).json();

	if (error.value) {
		console.error('Error fetching regions:', error);
		return [];
	}

	return data.value;
};

export const fetchAvailabilityResult = async (urlParams: string): Promise<AvailabilityResult | null> => {
	const url = `${catalogBaseUrl}/products/availability${urlParams}`;
	const {data, error} = await useFetch<{ data: AvailabilityResult }>(url).json();

	if (error.value) {
		console.error('Error fetching availability result:', error);
		return null;
	}

	return data.value;
};

export const fetchDetailResult = async (urlParams: string): Promise<DetailResult | null> => {
	const url = `${catalogBaseUrl}/products/detail${urlParams}`;

	const {data, error} = await useFetch<{ data: DetailResult }>(url).json();

	if (error.value) {
		console.error('Error fetching detail result:', error);
		return null;
	}

	return data.value;
};

export const fetchSubstitutes = async (region: string, patCode: string, queryParams: string) => {
	const url = `${catalogBaseUrl}/substitutes/${region}/${patCode}${queryParams}`;

	const {data, error} = await useFetch<{ data: Array<Product> }>(url).json();

	if (error.value) {
		console.error('Error fetching substitutes:', error);
		return null;
	}

	return data.value;
};

export const fetchPosMaterialResult = async (urlParams: string): Promise<PosMaterialResult | null> => {
	const url = `${catalogBaseUrl}/pos-materials/detail${urlParams}`;

	const {data, error} = await useFetch<{ data: Array<Product> }>(url).json();

	if (error.value) {
		console.error('Error fetching pos-materials:', error);
		return null;
	}

	return data.value;
};

export const getProductDetailUrl = (region: string, productId: string, productName: string, productGroup: string): string => {
	return `/app/${languageIso}/${productDetailPath}/${region}/${productGroup}/${productName}/${productId}`;
};

export const getSubstituteProductDetailUrl = (region: string, productId: string): string => {
	return `${window.productDetailBaseUrlWithoutRegion}/${region}/PAT_${productId}`;
};

export const getExportUrl = (region: string, urlParams: string): string => {
	return `${catalogBaseUrl}/products/availability/${region}/export${urlParams}`;
};
